import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { Heading, Button, Text, Tag } from "@chakra-ui/react"
import { FeaturedSection, FeaturedImage, Icon } from "../../"

export function LatestDevelopment() {
  const { allMdx } = useStaticQuery(graphql`
    {
      allMdx(
        limit: 1
        sort: { fields: [frontmatter___date], order: DESC }
        filter: {
          fileAbsolutePath: { regex: "/data/feed/" }
          frontmatter: { tag: { eq: "Project" } }
        }
      ) {
        nodes {
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            description
            title
            tag
            image {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  layout: FIXED
                  quality: 100
                  height: 400
                  width: 970
                )
              }
            }
          }
        }
      }
    }
  `)

  const { frontmatter, fields } = allMdx.nodes[0]

  return (
    <FeaturedSection>
      <FeaturedImage
        image={frontmatter.image}
        alt={frontmatter.title}
        reverse={true}
      >
        <Tag
          alignSelf="flex-start"
          colorScheme="base"
          variant="outline"
          size="md"
        >
          {frontmatter.tag}
        </Tag>

        <Heading fontWeight="semibold" letterSpacing="wide" size="3xl" as="h2">
          {frontmatter.title}
        </Heading>

        <Heading as="h4" size="lg" lineHeight="1.4" color="text.300">
          {frontmatter.description}
        </Heading>

        <Button as={Link} to={fields.slug} variant="primary">
          <Text as="span" lineHeight="1">
            READ
          </Text>
          <Icon name="arrowRight" boxSize={5} ml={3} />
        </Button>
      </FeaturedImage>
    </FeaturedSection>
  )
}
